export {
    default,
    FULLSCREEN_SIZE,
    DASHBOARD_SIZE,
    MODAL_SIZE,
    INLINE_SIZE,
    BUTTON_SIZE,
    BUTTON_SIZE_NO_PADDING,
    DEFAULT_LOADER_DELAY,
} from './CubeLoader';
